import { render } from "./Tower.vue?vue&type=template&id=bcd869bc&scoped=true"
import script from "./Tower.vue?vue&type=script&lang=js"
export * from "./Tower.vue?vue&type=script&lang=js"

import "./Tower.vue?vue&type=style&index=0&id=bcd869bc&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcd869bc"]])

export default __exports__